import { render } from "./MultiLanguageUpsellModal.vue?vue&type=template&id=66dc15ca&scoped=true"
import script from "./MultiLanguageUpsellModal.vue?vue&type=script&lang=js"
export * from "./MultiLanguageUpsellModal.vue?vue&type=script&lang=js"

import "./MultiLanguageUpsellModal.vue?vue&type=style&index=0&id=66dc15ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dc15ca"]])

export default __exports__